import edit_button from "../edit_button.html";

export default function (nga, admin) {
  var comboprices = admin.getEntity("comboPrices");
  comboprices
    .listView()
    .title(
      '<h4>Combo Prices <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga
        .field("price_id", "reference")
        .targetEntity(admin.getEntity("Prices"))
        .targetField(nga.field("package_name"))
        .label("Price"),
      nga
        .field("combo_id", "reference")
        .targetEntity(admin.getEntity("Combos"))
        .targetField(nga.field("name"))
        .label("Combo"),
    ])
    .listActions(["edit"])
    .exportFields([comboprices.listView().fields()]);

  comboprices
    .deletionView()
    .title(
      '<h4>Combo Prices <i class="fa fa-angle-right" aria-hidden="true"></i> Remove <span style ="color:red;"> {{ entry.values.package.package_name }} </span> from <span style ="color:red;"> {{ entry.values.combo.name }} </span></h4>'
    )
    .fields([
      nga.field("combo", "template").template(function (entry, value) {
        return entry.values.combo.name;
      }),
      nga.field("channel", "template").template(function (entry, value) {
        return entry.values.channel.title;
      }),
    ])
    .actions([
      '<ma-back-button entry="entry" entity="entity"></ma-back-button>',
    ]);

  comboprices
    .creationView()
    .onSubmitSuccess([
      "progression",
      "notification",
      "$state",
      "entry",
      "entity",
      function (progression, notification, $state, entry, entity) {
        progression.done();
        $state.go($state.get("edit"), {
          entity: "Combos",
          id: entry.values.combo_id,
        });
        return false;
      },
    ])
    .title("<h4>Link Price with Combo/Plan</h4>")
    .fields([
      nga
        .field("combo_id", "reference")
        .targetEntity(admin.getEntity("Combos"))
        .targetField(nga.field("name"))
        .perPage(-1)
        .validation({ required: true })
        .label("Product"),
      nga
        .field("price_id", "reference")
        .targetEntity(admin.getEntity("Prices"))
        .targetField(
          nga.field("name").map(function getpckdes(value, entry) {
            return (
              entry["name"] + " - " + entry["price_type.name"]
            );
          })
        )
        .perPage(-1)
        .validation({
          validator: function (value) {
            if (value === null || value === "") {
              throw new Error("Please Select Price");
            }
          },
        })
        .attributes({ placeholder: "Select prices" })
        .label("Price"),
      nga.field("template").label("").template(edit_button),
    ]);

  comboprices
    .editionView()
    .title(
      '<h4>Combo Prices <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.combo_id }}</h4>'
    )
    .actions(["list"])
    .fields([comboprices.creationView().fields()]);

  return comboprices;
}



// WEBPACK FOOTER //
// ./js/comboPrices/config.js